import styled from "styled-components";
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from "react-slick"

const Carousel = (props) => {

    //const numbCheck = window.screen.width < 760;
    let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              autoplay: true,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              autoplay: true,
            }
          }
        ]
      };

    // let settings = {
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow:  1,
    //     slidesToScroll: 1,
    //     autoplay: true,
    // }
    

    return(
        <Container>
            <SlickCarousel {...settings}>
                <div>
                    <img src="/images/gallery/slick1.jpg" alt =""/>
                    <h2>Investment Shares</h2>
                </div>
                <div>
                    <img src="/images/gallery/slick2.jpg" alt =""/>
                    <h2>Fund Management</h2>
                </div>
                
                <div>
                    <img src="/images/gallery/slick4.jpg" alt =""/>
                    <h2>Startup Funding</h2>
                </div>
                <div>
                    <img src="/images/gallery/slick5.jpg" alt =""/>
                    <h2>Loan Approval</h2>
                </div>
            </SlickCarousel>
        </Container>
    )
}


const SlickCarousel = styled(Slider)`
    
    img{
        width: 100%;
        padding-right: 20px;   
    }

    h2{
        text-align: center;
        @media(min-width: 768px){
            font-size: 25px;
            margin-top: 0;
        }
    }
    
`
const Container = styled.div`
    background: rgb(249, 250, 251);
    padding: 50px 0;
    padding-left: 20px;

`

export default Carousel